import React from "react";

function WorkPerson(props) {
  let colors = {
    mainColor: props.color || "black",
  };

  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 98 122.5"
      enable-background="new 0 0 98 98"
      fill={colors.mainColor}
    >
      <g>
        <polygon points="36.96,58.475 32.56,96.965 43.62,96.965 50.8,74.485 57.97,96.965 69.03,96.965 64.62,58.425  " />
        <path d="M65.06,24.505c-0.77-0.66-1.75-1.02-2.76-1.02h-6.93l-0.65,3.42l1.78,13.61l-5.7,6.06l-5.7-6.06l1.78-13.61l-0.65-3.43   h-6.94c-1.01,0-2,0.37-2.76,1.02l-14.44,12.38c-0.75,0.65-1.21,1.59-1.25,2.58c-0.05,0.9901,0.33,1.97,1.02,2.6801l8.45,8.7   c1.48,1.52,3.9,1.58,5.46,0.08c1.51-1.49,1.54-3.93,0.06-5.44l-5.13-5.28l6.39-5.47v21.75l27.41-0.05v-21.7l6.39,5.47l-5.13,5.27   c-1.48,1.52-1.45,3.98,0.08,5.45c1.51,1.47,3.93,1.46,5.44-0.07l8.47-8.7c0.69-0.71,1.06-1.69,1.02-2.69   c-0.05-0.99-0.51-1.93-1.27-2.58L65.06,24.505z" />
        <polygon points="50.73,43.725 54.32,39.905 52.63,26.915 53.45,22.565 48.01,22.565 48.83,26.915 47.14,39.905  " />
        <path d="M59.9,10.205c0-5.06-4.11-9.17-9.17-9.17c-5.05,0-9.17,4.11-9.17,9.17c0,5.05,4.12,9.16,9.17,9.16   C55.79,19.365,59.9,15.255,59.9,10.205z" />
        <path d="M90.06,51.415h-2c0,2.2156-1.7863,4.08-4.08,4.08v2c2.2586,0,4.08,1.8563,4.08,4.08h2c0-2.25,1.83-4.08,4.08-4.08v-2   C91.8886,55.495,90.06,53.6796,90.06,51.415z" />
        <path d="M74.46,11.915c0,2.3137-1.8885,4.08-4.07,4.08v2c2.2601,0,4.07,1.8372,4.07,4.08h2c0-2.25,1.83-4.08,4.08-4.08v-2   c-2.2234,0-4.08-1.8212-4.08-4.08H74.46z" />
        <rect x="83.5048" y="30.209" width="2" height="2" />
        <rect x="87.5048" y="30.209" width="2" height="2" />
        <rect x="91.5048" y="30.209" width="2" height="2" />
        <rect x="79.6385" y="3.6104" width="2" height="2" />
        <rect x="75.6385" y="3.6104" width="2" height="2" />
        <rect x="83.6385" y="3.6104" width="2" height="2" />
        <path d="M9.94,51.415h-2c0,2.2156-1.7863,4.08-4.08,4.08v2c2.25,0,4.08,1.83,4.08,4.08h2c0-2.3051,1.8803-4.08,4.08-4.08v-2   C11.782,55.495,9.94,53.709,9.94,51.415z" />
        <path d="M23.53,22.075c0-2.21,1.8013-4.08,4.08-4.08v-2c-2.2234,0-4.08-1.8212-4.08-4.08h-2c0,2.3262-1.9012,4.08-4.08,4.08v2   c2.25,0,4.08,1.83,4.08,4.08H23.53z" />
        <rect x="8.493" y="30.209" width="2" height="2" />
        <rect x="4.493" y="30.209" width="2" height="2" />
        <rect x="12.493" y="30.209" width="2" height="2" />
        <rect x="20.3593" y="3.6104" width="2" height="2" />
        <rect x="12.3593" y="3.6104" width="2" height="2" />
        <rect x="16.3593" y="3.6104" width="2" height="2" />
        <rect
          x="68.7589"
          y="71.9149"
          transform="matrix(0.1225 0.9925 -0.9925 0.1225 133.5765 -5.2533)"
          width="2.0004"
          height="1.9993"
        />
        <rect
          x="69.2483"
          y="75.8851"
          transform="matrix(0.9925 -0.1221 0.1221 0.9925 -8.8628 9.1534)"
          width="1.9993"
          height="1.9993"
        />
        <rect
          x="68.2702"
          y="67.9452"
          transform="matrix(-0.1221 -0.9925 0.9925 -0.1221 9.2955 146.1122)"
          width="2.0003"
          height="1.9993"
        />
        <rect
          x="69.7361"
          y="79.8553"
          transform="matrix(-0.1221 -0.9925 0.9925 -0.1221 -0.8808 160.9309)"
          width="2.0003"
          height="1.9993"
        />
        <rect
          x="30.6291"
          y="75.2728"
          transform="matrix(0.1221 -0.9925 0.9925 0.1221 -47.9351 98.3509)"
          width="1.9993"
          height="1.9993"
        />
        <rect
          x="30.1408"
          y="79.2426"
          transform="matrix(-0.9925 -0.1221 0.1221 -0.9925 52.2495 163.6875)"
          width="1.9993"
          height="2.0003"
        />
        <rect
          x="31.6067"
          y="67.3324"
          transform="matrix(0.9925 0.1221 -0.1221 0.9925 8.5882 -3.4702)"
          width="1.9993"
          height="2.0003"
        />
        <rect
          x="31.1179"
          y="71.3021"
          transform="matrix(-0.9925 -0.1221 0.1221 -0.9925 55.1659 147.9854)"
          width="1.9993"
          height="2.0004"
        />
      </g>
    </svg>
  );
}

export default WorkPerson;
